export const Bindings = {
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	GlobalApiHTTPClient: Symbol("GlobalApiHTTPClient"),
	UserApiProvider: Symbol("UserApiProvider"),
	GeoApiProvider: Symbol("GeoApiProvider"),
	LeaguesApiProvider: Symbol("LeaguesApiProvider"),
	PasswordApiProvider: Symbol("PasswordApiProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	CountriesStore: Symbol("CountriesStore"),
	RoundsStore: Symbol("RoundsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	UserStore: Symbol("UserStore"),
	GeoStore: Symbol("GeoStore"),
	LocalizationStore: Symbol("LocalizationStore"),
	StaticContentStore: Symbol("StaticContentStore"),
	AuthController: Symbol("AuthController"),
	LoginController: Symbol("LoginController"),
	RegistrationController: Symbol("RegistrationController"),
	MyAccountController: Symbol("MyAccountController"),
	SecretGateController: Symbol("SecretGateController"),
	HelpController: Symbol("HelpController"),
	HelpListController: Symbol("HelpListController"),
	ContactUsController: Symbol("ContactUsController"),
	ChecksumStore: Symbol("ChecksumStore"),
	LiveScoreController: Symbol("LiveScoreController"),
	ForgotPasswordController: Symbol("ForgotPasswordController"),
	ResetPasswordController: Symbol("ResetPasswordController"),
	SessionController: Symbol("SessionController"),
	BootstrapController: Symbol("BootstrapController"),
	LeaguesStore: Symbol("LeaguesStore"),
	MyLeaguesController: Symbol("MyLeaguesController"),
	JoinLeaguesController: Symbol("JoinLeaguesController"),
	CreateLeagueController: Symbol("CreateLeagueController"),
	LeagueController: Symbol("LeagueController"),
	LeagueInviteController: Symbol("LeagueInviteController"),
	LeagueSettingsController: Symbol("LeagueSettingsController"),
	LeagueAboutController: Symbol("LeagueAboutController"),
	LeagueInviteFormController: Symbol("LeagueInviteFormController"),
	ModalsStore: Symbol("ModalsStore"),
	ModalErrorController: Symbol("ModalErrorController"),
	ModalConfirmController: Symbol("ModalConfirmController"),
	ModalShareController: Symbol("ModalShareController"),
	LocalizationController: Symbol("LocalizationController"),
	BackdoorController: Symbol("BackdoorController"),
	HeaderController: Symbol("HeaderController"),
	MenuStore: Symbol("MenuStore"),
	MenuToggleController: Symbol("MenuToggleController"),
	ContestsStore: Symbol("ContestsStore"),
	GamesStore: Symbol("GamesStore"),
	ContestPlayersStore: Symbol("ContestPlayersStore"),
	PredictionApiProvider: Symbol("PredictionApiProvider"),
	PredictionsStore: Symbol("PredictionsStore"),
	HomeController: Symbol("HomeController"),
	PlayersController: Symbol("PlayersController"),
	ContestCardController: Symbol("ContestCardController"),
	PlayerCardController: Symbol("PlayerCardController"),
	ModalSecondaryRegistrationController: Symbol("ModalSecondaryRegistrationController"),
	ContestInfoController: Symbol("ContestInfoController"),
	SaveBarController: Symbol("SaveBarController"),
	WinnerCardController: Symbol("WinnerCardController"),
	ModalSaveLocalController: Symbol("ModalSaveLocalController"),
	LivePlayersController: Symbol("LivePlayersController"),
	LeaderboardController: Symbol("LeaderboardController"),
	RankingApiProvider: Symbol("RankingProvider"),
	RankingStore: Symbol("RankingStore"),
	LeaderboardTableController: Symbol("LeaderboardTableController"),
	LeaderboardRowController: Symbol("LeaderboardRowController"),
	ResultsController: Symbol("ResultsController"),
	WinnerCardResultedController: Symbol("WinnerCardResultedController"),
	ContextualPromptBannerController: Symbol("ContextualPromptBannerController"),
	ContextualPromptBannerProvider: Symbol("ContextualPromptBannerProvider"),
	ContextualPromptBannerStore: Symbol("ContextualPromptBannerStore"),
	SharingStore: Symbol("SharingStore"),
	SharingController: Symbol("SharingController"),
};
